import { render, staticRenderFns } from "./HsabInvestmentAccountPage.vue?vue&type=template&id=238245a2"
import script from "./HsabInvestmentAccountPage.vue?vue&type=script&lang=ts"
export * from "./HsabInvestmentAccountPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports